/* eslint-disable */
import React, { useState, useEffect, Fragment } from 'react';
import { Data, Filters } from './contexts';
import { ToastContainer, toast } from 'react-toastify';
import DashboardViewModal from './utils/DashboardViewModal';
import DashboardViewControls from './utils/DashboardViewControls';
import EditParentChildDashboard from './utils/EditParentChildDashboard';
import ParentDashboard from './ParentDashboard';
// import DropdownFilter from '../utils/DropdownFilter';
import LoaderGraphic from '../utils/LoaderGraphic';
import { capitalize } from '../utils';
import AccountTree from '../utils/AccountTree';
// import { LinesChart, ColumnsChart, LineColChart, ColLineChart } from '../utils/SVGIcons';
import { customersFinancialDetailRows, customersKPIsFormat, updateCustomersRows, addMetricRow } from '../utils/CustomerSheets';
import { defaultLayouts, moneyCharts, peopleCharts, customerCharts, mergeItems, layoutMaker, pageCharts } from './charts';
import { useTour } from '@reactour/tour';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import ahoy from 'ahoy.js';
import Modal from 'react-modal';

const DashboardViewEditorPage = (props) => {
    const { isOpen, currentStep, setIsOpen, setCurrentStep } = useTour();
    const navbar = window.navbar.navbar;
    // set default report period to annual/years options
    const [state, setState] = useState({
        report: 'money',
        pageTitle: capitalize("money") || '',
        clientName: props.client_name || '',
        naics_list: props.naics_list || [],
        child_companies_list: props.child_companies_list || [],
        calendarYearEnd: props.calendarYearEnd,
        fiscalYearStartMonth: props.fiscalYearStartMonth || 1,
        peerviewMetricsYears: props.peerviewMetricsYears || {},
        calcs: props.calcs,
        monthly_calcs: props.monthly_calcs,
        baseCalc: {},
        monthlyForecastCalcs: {},
        fetch: !props.calcs,
        loading: false,
        filters: props.filters || {},
        filterOptions: props.filterOptions || {},
        youAnnualOptions: {},
        youMonthlyOptions: {},
        peerAnnualOptions: {},
        peerMonthlyOptions: {},
        monthlyCompareWithOptions: [],
        tree: props.tree,
        yearRange: props.yearRange || [],
        n: props.n,
        docs_n: 0,
        forecast_scenarios: [],
        insufficient_data: false,
        insufficient_peer_data: false,
        reportSpecific: props.reportSpecific || {},
        isMonthlyAvailable: props.isMonthlyAvailable,
        quarterMonths: ['Q1', [1, 2, 3]],
        trendData: null,
        fiscalYearEnd: props.fiscal_year_end,
        companyYTDDate: null,
        aggregateYTDDate: null,
        companyReportSurvey: {},
        surveyTaken: false,
        surveyResults: {},
        pnlTree: {},
        balTree: {},
    });
    const [naicsForm, setNaicsForm] = useState({
        naics_id: props.naics_id,
        naics_code: props.code,
        naics_name: props.naics_name
    })
    const [companyForm, setCompanyForm] = useState({
        id: props.id,
    })
    const [filtersModalIsOpen, setFiltersModalIsOpen] = useState(false)
    const [dashboard, setDashboard] = useState({ id: null, selectedItems: [], layout: [], noChangesMade: true });
    const [editDashboard, setEditDashboard] = useState({
        money: [{ sectionName: 'Money Peerview Metrics', sheet: 'peerview_charts', showDropdown: false }, { sectionName: 'Profit & Loss', sheet: 'pnl', showDropdown: false }, { sectionName: 'Balance Sheet', sheet: 'balance_sheet', showDropdown: false }, { sectionName: 'Cash Flow', sheet: 'cash_flow', showDropdown: false }, { sectionName: `KFI's`, sheet: 'kfis', showDropdown: false }],
        people: [{ sectionName: 'People Peerview Metrics', sheet: 'people_peerview_charts', showDropdown: false }, { sectionName: 'People Financial Detail', sheet: 'people_financial_detail', showDropdown: false }, { sectionName: `People KPI`, sheet: 'people_kpi', showDropdown: false }],
        customers: [{ sectionName: 'Customers Peerview Metrics', sheet: 'customers_peerview_charts', showDropdown: false }, { sectionName: 'Customers Financial Detail', sheet: 'customers_financial_detail', showDropdown: false }, { sectionName: `Customers KPI`, sheet: 'customers_kpi', showDropdown: false }]
    })
    const [dashboardViewModalState, setDashboardViewModalState] = useState({
        isOpen: false,
        action: 'close',
        edit_view: props.current_view || {},
        current_view: props.current_view || {},
        user_views: props.admin_editor ? props.admin_dashboards : props.normal_custom_dashboards,
        metric_key: null,
        metric_name: null,
        pvdAccountsWithKeys: props.pvd_accounts_with_keys || [],
        naicsSpecific: 'no',
        parentSpecific: 'no',
        naicsSearch: [],
        parentSearch: [],
        companySearch: []
    });
    const [reportMetrics, setReportMetrics] = useState({
        id: null,
        editMetrics: false,
        layout: [],
        peerview_charts: [],
        pnl: [],
        balance_sheet: [],
        cash_flow: [],
        kfis: [],
        people_peerview_charts: [],
        people_financial_detail: [],
        people_kpi: [],
        customers_peerview_charts: [],
        customers_financial_detail: [],
        customers_kpi: [],
        financial_detail: [],
        kpi: [],
        allSelectedMetrics: [],
        allSheetMetrics: [],
        noChangesMade: true,
    });
    const [editChartModel, setEditChartModel] = useState({
        isOpen: false,
        chartDetails: null,
        childItem: false,
        highChartOptions: null,
        oldStyles: { seriesOne: { type: 'column' }, seriesTwo: { type: 'column' } },
        newStyles: { seriesOne: { type: 'column' }, seriesTwo: { type: 'column' } }
    })

    const TourBtn = () => {
        const questionCircle = <FontAwesomeIcon icon={faQuestionCircle} />
        return (
            <button className='hide-on-print' onClick={() => setIsOpen(true)}>{questionCircle}</button>
        )
    }

    const moneyTreesBuilder = (selectedItems, tree, displayByView = 'yearsView') => {
        let pnlOnePageRows = [];
        let balOnePageRows = [];
        let cashFlowRows = [];
        let kfisRows = [];
        const pnlTree = new AccountTree({
            tree: tree['pnl'],
            page: 'money',
            sheet: 'pnl',
            displayByView: displayByView,
            selectedMetrics: selectedItems['pnl'],
            dashBoardEditor: true
        })
        pnlTree.forEach((row) => {
            pnlOnePageRows.push(row)
        })
        pnlOnePageRows = pnlOnePageRows.filter(Boolean)

        const balTree = new AccountTree({
            tree: tree['balance_sheet'],
            page: 'money',
            sheet: 'balance_sheet',
            displayByView: displayByView,
            selectedMetrics: selectedItems['balance_sheet'],
            dashBoardEditor: true
        })
        balTree.forEach((row) => {
            balOnePageRows.push(row)
        })
        balOnePageRows = balOnePageRows.filter(Boolean)

        const cashFlowTree = new AccountTree({
            tree: tree['cash_flow'],
            page: 'money',
            sheet: 'cash_flow',
            displayByView: displayByView,
            selectedMetrics: selectedItems['cash_flow'],
            dashBoardEditor: true
        })
        cashFlowTree.forEach((row) => {
            cashFlowRows.push(row)
        })
        cashFlowRows = cashFlowRows.filter(Boolean)

        const kfisTree = new AccountTree({
            tree: tree['kfis'],
            page: 'money',
            sheet: 'kfis',
            displayByView: displayByView,
            selectedMetrics: selectedItems['kfis'],
            dashBoardEditor: true
        })
        kfisTree.forEach((row) => {
            kfisRows.push(row)
        })
        kfisRows = kfisRows.filter(Boolean)
        return { pnlOnePageRows, balOnePageRows, cashFlowRows, kfisRows }
    }

    const peopleTreesBuilder = (selectedItems, tree, displayByView = 'yearsView') => {
        let peopleFinancialDetailRows = [];
        let peopleKpiRows = [];

        const pnlTree = new AccountTree({
            tree: tree['pnl'],
            page: 'people',
            sheet: 'pnl',
            displayByView: displayByView,
            selectedMetrics: selectedItems['people_financial_detail'],
            dashBoardEditor: true
        })
        pnlTree.forEach((row) => {
            peopleFinancialDetailRows.push(row)
        })
        peopleFinancialDetailRows = peopleFinancialDetailRows.filter(Boolean)

        const kpiTree = new AccountTree({
            tree: tree['kpi_people'],
            page: 'people',
            sheet: 'kpi_people',
            displayByView: displayByView,
            selectedMetrics: selectedItems['people_kpi'],
            dashBoardEditor: true
        })
        kpiTree.forEach((row) => {
            peopleKpiRows.push(row)
        })
        peopleKpiRows = peopleKpiRows.filter(Boolean)

        return { peopleFinancialDetailRows, peopleKpiRows }
    }

    const handleEditDashBoard = (sheet, report = null) => {
        let finalEditSections = null
        setEditDashboard((prevState) => {
            if (report) {
                finalEditSections = _.cloneDeep(prevState)
                finalEditSections[report] = finalEditSections[report].map(section => {
                    if (section['sheet'] === sheet) {
                        section['showDropdown'] = !section['showDropdown']
                    }
                    return section;
                })
            } else {
                let newEditSections = _.cloneDeep(prevState)
                finalEditSections = newEditSections.map(section => {
                    if (section['sheet'] === sheet) {
                        section['showDropdown'] = !section['showDropdown']
                    }
                    return section;
                })
            }

            return finalEditSections;
        })
    }

    const handleMoneyNotes = (newNotes) => {
        setMoneyNotes(() => {
            return {
                userNotes: newNotes
            }
        })
        setReportMetrics(prevState => {
            let currentView = dashboardViewModalState.current_view
            let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)
            return {
                ...prevState,
                noChangesMade: noChangesVal
            }
        })
    }

    const editingParentAndChildLayouts = (report, metricKey, childLayoutKey, selectedMetrics, oldDashboardLayout, oldAllSheetMetrics) => {
        let newLayout = []
        let newSheetRows = null;
        // Toggling a child key in a child/nested layout
        if (childLayoutKey) {
            let childLayout, childMetric = null;
            // Look for parent of child key in previous selected metrics
            let parentMetricIndex = selectedMetrics.findIndex(checked => checked['relatedCheckedKey'] === metricKey);
            if (selectedMetrics[parentMetricIndex]) {
                if (!selectedMetrics[parentMetricIndex].layout) {
                    selectedMetrics.splice(parentMetricIndex, 1)
                }
            }
            // update the rows and selection pop up for checked metrics
            // add or remove any metrics for the new check metrics to build the dashboard layout
            newSheetRows = oldAllSheetMetrics.map(m => {
                // Look for parent of child key in previous selected metrics
                let parentMetricIndex = selectedMetrics.findIndex(checked => checked['relatedCheckedKey'] === metricKey);

                if (m['relatedCheckedKey'] === metricKey && m['displayChart']) {
                    let childCheckedItemsNumber = 0;
                    let childItem = null;

                    if (m.layout.length > 0) {
                        m.layout = m.layout.map(i => {
                            if (i.key.includes('total_revenue_growth_rate_')) {
                                i.key = i.key.replace('total_revenue_growth_rate_', 'total_revenue_')
                            }
                            if (i.key === 'total_revenue_bar_chart') {
                                i.key = 'total_revenue_growth_rate'
                            }
                            i.checked = i.key === childLayoutKey ? !i.checked : i.checked;

                            if (i.checked) {
                                childCheckedItemsNumber += 1
                            }
                            return i;
                        })
                    }

                    if (childCheckedItemsNumber) {
                        m['checked'] = true
                        // if parent doesn't exist in selectedMetrics
                        if (parentMetricIndex < 0) {
                            let newMetric = _.cloneDeep(m)
                            newMetric.layout = newMetric.layout.filter(item => item.checked)
                            // 1 child doesn't need child layout
                            if (newMetric.layout.length === 1) {
                                let soloChild = newMetric.layout[0]
                                soloChild.metricRow = m
                                if (!Object.hasOwnProperty('relatedCheckedKey')) { soloChild['relatedCheckedKey'] = soloChild.metricRow['relatedCheckedKey'] }
                                selectedMetrics.push(soloChild)
                            } else {
                                selectedMetrics.push(newMetric)
                            }
                        } else {
                            // if parent exists
                            let newMetric = _.cloneDeep(m)
                            let newChildLayout = newMetric.layout.filter(item => item.checked)
                            // 1 child doesn't need child layout
                            if (newChildLayout.length === 1) {
                                // Check if metric already selected from the Money, People, or Customers. Stay with metric from Money P&L if it already is selected.
                                let metricAlreadySelected = selectedMetrics.find(s => s.key === newChildLayout[0].key)
                                if (!metricAlreadySelected || (metricAlreadySelected && newChildLayout[0]['metricRow'] && newChildLayout[0]['metricRow']['sheet'] === 'pnl')) {
                                    selectedMetrics.splice(parentMetricIndex, 1)
                                    let soloChild = newChildLayout[0]
                                    soloChild.metricRow = m
                                    if (!Object.hasOwnProperty('relatedCheckedKey')) { soloChild['relatedCheckedKey'] = soloChild.metricRow['relatedCheckedKey'] }
                                    selectedMetrics.push(soloChild)
                                }
                            } else {
                                // handle parent metrics with child layouts
                                if (selectedMetrics[parentMetricIndex].layout) {
                                    selectedMetrics[parentMetricIndex].layout = newChildLayout
                                } else {
                                    // More than 1 child will need a parent
                                    selectedMetrics.splice(parentMetricIndex, 1)
                                    newMetric.layout = newChildLayout;
                                    selectedMetrics.push(newMetric)
                                }
                            }
                        }
                    } else {
                        // if no child keys are checked remove the parent metric if exists
                        m['checked'] = false
                        if (parentMetricIndex > -1) { selectedMetrics.splice(parentMetricIndex, 1) }
                    }
                }
                return m;
            })
        } else {
            // Deals with metrics not in child layouts
            let oneAlreadyFound = 0
            let allChecked = null;

            newSheetRows = oldAllSheetMetrics.map(m => {
                let checkedMetricIndex = selectedMetrics.findIndex(checked => checked['relatedCheckedKey'] === metricKey)

                if ((m['relatedCheckedKey'] === metricKey && m['displayChart']) || (report === 'customers' && m['relatedCheckedKey'] === metricKey && m['displayChart'])) {
                    m['checked'] = oneAlreadyFound ? allChecked : !m['checked']
                    oneAlreadyFound += 1
                    if (oneAlreadyFound === 1) { allChecked = m['checked'] }

                    if (m.layout && m.layout.length > 0) {
                        m.layout = m.layout.map(i => {
                            if (!i.key.includes('_notes') && m['checked']) {
                                i.checked = m['checked'];
                            } else if (!m['checked']) {
                                i.checked = false
                            }
                            return i;
                        })
                    }

                    if (m['checked']) {
                        if (checkedMetricIndex < 0) {
                            m.onManyReports = oneAlreadyFound > 1
                            selectedMetrics.push(m)
                        }
                    } else {
                        if (checkedMetricIndex > -1) {
                            selectedMetrics.splice(checkedMetricIndex, 1)
                        }
                    }
                }
                return m
            })
        }

        selectedMetrics.forEach((s, i) => {
            let oldParentItem = null;
            let parentLayout = [];
            oldParentItem = oldDashboardLayout.find(o => o['i'] === s.key);
            if (oldParentItem && s.layout) {
                let parentH = 2;
                let parentW = 3;
                let widthCounter = 0
                s.layout.forEach((c) => {
                    let oldChildItem = oldParentItem.layout.find(l => l.i === c.key)
                    if (oldChildItem && c['checked']) {
                        parentLayout.push(oldChildItem)
                        if (widthCounter >= 3) {
                            parentH += oldChildItem.h;
                            widthCounter = 0
                        }
                        parentW += oldChildItem.w;
                        widthCounter += oldChildItem.w;
                    } else if (c['checked']) {
                        let newChildItem = layoutMaker(c, i)
                        parentLayout.push(newChildItem)
                        if (widthCounter >= 3) {
                            parentH += newChildItem.h;
                            widthCounter = 0
                        }
                        parentW += newChildItem.w;
                        widthCounter += newChildItem.w;
                    }
                })

                oldParentItem.layout = parentLayout;
                oldParentItem.w = parentW > 3 ? 3 : parentW
                oldParentItem.h = parentH
                newLayout.push(oldParentItem)
            } else if (oldParentItem) {
                newLayout.push(oldParentItem)
            } else {
                // parent with kids
                if (s['layout']) {
                    let parentH = 2;
                    let parentW = 3;
                    let widthCounter = 0
                    let miniLayout = s['layout'].filter(child => child['checked']).map((l, i) => {
                        let layoutItem = layoutMaker(l, i)
                        if (widthCounter >= 3) {
                            parentH += layoutItem.h;
                            widthCounter = 0
                        }
                        parentW += layoutItem.w;
                        widthCounter += layoutItem.w;
                        return layoutItem;
                    })
                    newLayout.push({
                        i: s.key,
                        isBounded: false,
                        isDraggable: true,
                        isResizable: true,
                        x: ((i * 3) % (6)),
                        y: Infinity,
                        w: parentW > 3 ? 3 : parentW,
                        h: parentH,
                        minW: 1,
                        minH: 1,
                        maxW: 6,
                        maxH: 12,
                        resizeHandles: ['se'],
                        layout: miniLayout,
                        metricRow: s
                    })
                } else {
                    // no kids
                    let layoutItem = layoutMaker(s, metricKey)
                    newLayout.push(layoutItem);
                }
            }
        })

        return { newRows: newSheetRows, newLayout: newLayout };
    }

    const handleSelectAndLayout = (page, sheet, metricKey, childLayoutKey = '', report = null) => {
        let newLayout = []
        let selectedMetrics = null;

        setReportMetrics((prevState) => {
            selectedMetrics = _.cloneDeep(prevState.allSelectedMetrics);
            let newSheetRows = null;
            let oldDashboardLayout = _.cloneDeep(prevState.layout)
            let oldAllSheetMetrics = _.cloneDeep(prevState.allSheetMetrics)
            let actualPage = page === 'money' ? report : page
            let { newRows, newLayout } = editingParentAndChildLayouts(actualPage, metricKey, childLayoutKey, selectedMetrics, oldDashboardLayout, oldAllSheetMetrics)

            return {
                ...prevState,
                peerview_charts: newRows.filter(m => m.sheet === 'peerview_charts'),
                pnl: newRows.filter(m => m.sheet === 'pnl'),
                balance_sheet: newRows.filter(m => m.sheet === 'balance_sheet'),
                cash_flow: newRows.filter(m => m.sheet === 'cash_flow'),
                kfis: newRows.filter(m => m.sheet === 'kfis'),
                people_peerview_charts: newRows.filter(m => m.sheet === 'people_peerview_charts'),
                people_financial_detail: newRows.filter(m => m.sheet === 'people_financial_detail'),
                people_kpi: newRows.filter(m => m.sheet === 'people_kpi'),
                customers_peerview_charts: newRows.filter(m => m.sheet === 'customers_peerview_charts'),
                customers_financial_detail: newRows.filter(m => m.sheet === 'customers_financial_detail'),
                customers_kpi: newRows.filter(m => m.sheet === 'customers_kpi'),
                allSelectedMetrics: selectedMetrics,
                allSheetMetrics: newRows,
                layout: newLayout,
                noChangesMade: false
            }
        })

    }

    const handleDashboardSelections = (item, parentItemInfo = null) => {
        let itemsCheckedTrue = [];
        setDashboard((prevState) => {
            let oldDashInfo = _.cloneDeep(prevState);
            if (parentItemInfo) {
                let parentItem = oldDashInfo.selectedItems.find((c) => c.key === parentItemInfo.key);
                if (parentItem.children) {
                    let childItem = parentItem.children.find((child) => child.key === item.key);
                    childItem.checked = !childItem.checked
                    let numberOfChildrenChecked = parentItem.children.filter(child => child.checked)
                    parentItem.checked = numberOfChildrenChecked.length > 0
                }
            } else {
                let selectedChart = oldDashInfo.selectedItems.find((c) => c.key === item.key);
                let checkStatus = !selectedChart.checked
                if (selectedChart.children) {
                    selectedChart.children = selectedChart.children.map((c) => {
                        c.checked = checkStatus
                        return c;
                    })
                }
                selectedChart.checked = checkStatus;
            }

            oldDashInfo.selectedItems.forEach((c) => {
                if (c.checked) {
                    itemsCheckedTrue.push(c.key)
                }
            })

            let chartsLength = itemsCheckedTrue.length;
            let newLayout = itemsCheckedTrue.map((c, i) => {
                let itemLayout = oldDashInfo.layout.find((d) => d['i'] === c);
                if (itemLayout) {
                    return itemLayout
                } else {
                    if (c.includes('_gauges')) {
                        return { i: c, isBounded: false, isDraggable: true, isResizable: false, x: 0, y: 0, w: 6, h: 1, minW: 6, minH: 1, maxW: 6, maxH: 12, resizeHandles: ['se'] }
                    } else if (c.includes('pie')) {
                        return {
                            i: c,
                            isBounded: false,
                            isDraggable: true,
                            isResizable: true,
                            x: ((i * 2) % (6)),
                            y: ((i * 2) % (3)),
                            w: 2,
                            h: 2,
                            minW: 1,
                            minH: 1,
                            maxW: 6,
                            maxH: 12,
                            resizeHandles: ['se']
                        }
                    } else {
                        return {
                            i: c,
                            isBounded: false,
                            isDraggable: true,
                            isResizable: true,
                            x: ((i * 2) % (6)),
                            y: Infinity,
                            w: 2,
                            h: 1,
                            minW: 1,
                            minH: 1,
                            maxW: 6,
                            maxH: 12,
                            resizeHandles: ['se']
                        }
                    }
                }
            })

            return { ...prevState, selectedItems: oldDashInfo.selectedItems, layout: newLayout, noChangesMade: false }
        })
    }

    const handleSelectAll = (select) => {
        setDashboard((prevState) => {
            let newLayout = []
            let oldDashInfo = _.cloneDeep(prevState);
            let allItems = oldDashInfo.selectedItems.map((item) => {
                if (item.children) {
                    item.children = item.children.map((c) => {
                        c.checked = select
                        return c;
                    })
                }
                item.checked = select;
                return item;
            })

            allItems.forEach((c, i) => {
                if (c.checked) {
                    let itemLayout = oldDashInfo.layout.find((d) => d['i'] === c.key);
                    if (itemLayout) {
                        newLayout.push(itemLayout)
                    } else {
                        if (c.key.includes('_gauges')) {
                            newLayout.push({ i: c.key, isBounded: false, isDraggable: true, isResizable: false, x: 0, y: 0, w: 6, h: 1, minW: 6, minH: 1, maxW: 6, maxH: 12, resizeHandles: ['se'] })
                        } else if (c.key.includes('pie')) {
                            newLayout.push({
                                i: c.key,
                                isBounded: false,
                                isDraggable: true,
                                isResizable: true,
                                x: ((i * 2) % (6)),
                                y: ((i * 2) % (3)),
                                w: 2,
                                h: 2,
                                minW: 1,
                                minH: 1,
                                maxW: 6,
                                maxH: 12,
                                resizeHandles: ['se']
                            })
                        } else {
                            newLayout.push({
                                i: c.key,
                                isBounded: false,
                                isDraggable: true,
                                isResizable: true,
                                x: ((i * 2) % (6)),
                                y: Infinity,
                                w: 2,
                                h: 1,
                                minW: 1,
                                minH: 1,
                                maxW: 6,
                                maxH: 12,
                                resizeHandles: ['se']
                            })
                        }
                    }
                }
            })

            return { ...prevState, selectedItems: allItems, layout: newLayout, noChangesMade: false }
        })
    }

    const createDashBoardView = async (newDashView) => {
        if (newDashView.viewApply === 'all_firm_clients_naics') {
            let company = state.child_companies_list.find(c => c[0] === companyForm.id)
            newDashView.naics = [company[3]]
        }

        let newView = {
            company_id: props.admin_editor ? null : companyForm.id,
            editor_page: true,
            name: newDashView.name,
            report_type: 'money',
            private: newDashView.viewVisibilty === 'only_me',
            permission_details: newDashView.viewPermission,
            view_apply: newDashView.viewApply,
            admin_custom_default: props.admin_editor,
            normal_custom: !props.admin_editor,
            naics: newDashView.naics,
            parent_ids: newDashView.parent_ids,
            company_ids: newDashView.company_ids,
            metric_key: newDashView.metricKey,
            metric_name: newDashView.metricName
        }

        if (report === 'money') {
            newView['selected_items'] = {
                peerview_charts: reportMetrics['peerview_charts'],
                pnl: reportMetrics['pnl'],
                balance_sheet: reportMetrics['balance_sheet'],
                cash_flow: reportMetrics['cash_flow'],
                kfis: reportMetrics['kfis'],
                money_all_selected_items: reportMetrics['allSelectedMetrics'],
                money_user_notes: '',
                people_peerview_charts: reportMetrics['people_peerview_charts'],
                people_financial_detail: reportMetrics['people_financial_detail'],
                people_kpi: reportMetrics['people_kpi'],
                customers_peerview_charts: reportMetrics['customers_peerview_charts'],
                customers_financial_detail: reportMetrics['customers_financial_detail'],
                customers_kpi: reportMetrics['customers_kpi'],
            }
            newView['dashboard_layout'] = reportMetrics['layout']
        }

        try {
            const res = await fetch(`/dashboard_views`, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': window.token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newView),
            })
            const dashViewRes = await res.json();

            if (!res.ok) {
                throw new Error('Network response was not ok.');
            } else {
                if (report === 'money') {
                    setReportMetrics(prevState => {
                        return {
                            ...prevState,
                            id: dashViewRes.current_view.id,
                            noChangesMade: true
                        }
                    })

                    setDashboardViewModalState(prevState => {
                        return {
                            ...prevState,
                            current_view: dashViewRes.current_view,
                            user_views: dashViewRes.user_views,
                            isOpen: false
                        }
                    })
                }
                toast.success('New view created!', {
                    position: 'top-right',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.log(error);
            toast.error(`Sorry something went wrong. ${error}.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
    }

    // Need to Update here
    const getDashBoardView = async (dashViewId) => {
        try {
            const res = await fetch(`/dashboard_views/${dashViewId}?editor_page=true`, {
                method: 'GET',
                headers: {
                    'X-CSRF-Token': window.token,
                    'Content-Type': 'application/json',
                },
            })
            const dashViewRes = await res.json();

            if (!res.ok) {
                throw new Error('Network response was not ok.');
            } else {
                let currentDash = dashViewRes['current_view']
                if (report === 'money') {
                    let allSelectedKeys = []
                    let layout = [];
                    let peerviewCharts = null;
                    let peerviewChartsSelected = [];
                    let peopleLayout = [];
                    let peoplePeerviewCharts = [];
                    let peoplePeerviewChartsSelected = [];
                    let peopleFDRows = []
                    let customersLayout = [];
                    let customersPeerviewCharts = [];
                    let customersPeerviewChartsSelected = [];
                    let customersFDRows = []
                    let customersKpiRows = customersKPIsFormat(filters['display_columns_by'], filters['report_period']);

                    if (currentDash['selected_items']['peerview_charts'].length) {
                        let { selectedItems } = mergeItems(report, currentDash['selected_items']['peerview_charts'], []);
                        peerviewCharts = selectedItems;
                        peerviewCharts.forEach((chart) => {
                            if (chart.checked) {
                                peerviewChartsSelected.push(chart)
                            }
                        })

                        layout = currentDash['dashboard_layout']
                    } else {
                        peerviewCharts = moneyCharts['peerview_charts']
                        peerviewCharts.forEach((chart) => {
                            if (chart.checked) {
                                let defaultLayout = defaultLayouts['money_peerview_charts'].find((l) => l.i === chart.key)
                                if (defaultLayout) {
                                    layout.push(defaultLayout)
                                    peerviewChartsSelected.push(chart)
                                }
                            }
                        })
                    }

                    if (currentDash['selected_items'] && currentDash['selected_items']['people_peerview_charts'] && currentDash['selected_items']['people_peerview_charts'].length > 0) {
                        let { selectedItems } = mergeItems('people', currentDash['selected_items']['people_peerview_charts'], []);
                        peoplePeerviewCharts = selectedItems;
                    } else {
                        peoplePeerviewCharts = peopleCharts['peerview_charts']
                    }

                    if (currentDash['selected_items'] && currentDash['selected_items']['customers_peerview_charts'] && currentDash['selected_items']['customers_peerview_charts'].length > 0) {
                        let { selectedItems } = mergeItems('customers', currentDash['selected_items']['customers_peerview_charts'], []);
                        customersPeerviewCharts = selectedItems;
                    } else {
                        customersPeerviewCharts = customerCharts['peerview_charts']
                    }

                    let displayByView = 'yearsView'
                    if (filters['display_columns_by'] === 'Years' && filters['report_period'] === 'Year to Date') {
                        displayByView = 'ytdView'
                    }
                    if (filters['display_columns_by'] === 'Months') {
                        displayByView = 'monthsView'
                    }
                    // Money is going to have all people and customers
                    if (report === 'money') {
                        let { pnlOnePageRows, balOnePageRows, cashFlowRows, kfisRows } = moneyTreesBuilder(currentDash['selected_items'], state.tree, displayByView)
                        let { peopleFinancialDetailRows, peopleKpiRows } = peopleTreesBuilder(currentDash['selected_items'], state.tree, displayByView)

                        // People & Customers contain similar metrics found in Money P&L
                        if (!currentDash['selected_items']['people_financial_detail']) {
                            peopleFDRows = updatePeopleCustomersChecks(peopleFinancialDetailRows, currentDash['selected_items']['pnl'])
                        } else {
                            peopleFDRows = peopleFinancialDetailRows
                        }

                        if (!currentDash['selected_items']['customers_financial_detail']) {
                            customersFDRows = updatePeopleCustomersChecks(customersFinancialDetailRows, currentDash['selected_items']['pnl'])
                        } else {
                            customersFDRows = updateCustomersRows(currentDash['selected_items']['customers_financial_detail'], customersFinancialDetailRows)
                        }

                        if (!currentDash['selected_items']['customers_kpi']) {
                            customersKpiRows = updatePeopleCustomersChecks(customersKpiRows, currentDash['selected_items']['pnl'])
                        } else {
                            customersKpiRows = updateCustomersRows(currentDash['selected_items']['customers_kpi'], customersKpiRows)
                        }

                        let selectedItems = currentDash['selected_items']['money_all_selected_items'].length > 0 ? currentDash['selected_items']['money_all_selected_items'] : peerviewChartsSelected;
                        currentDash.selected_items = selectedItems
                        currentDash.dashboard_layout = layout
                        let naicsSpecific = 'no';
                        let parentSpecific = 'no';
                        let naicsSearch = [];
                        let parentSearch = [];
                        let companySearch = [];
                        if (currentDash.naics && currentDash.naics.length > 0) {
                            naicsSpecific = 'yes'
                            naicsSearch = currentDash.naics
                        }
                        if (currentDash.parent_ids && currentDash.parent_ids.length > 0) {
                            parentSpecific = 'yes'
                            parentSearch = currentDash.parent_companies
                        }
                        if (currentDash.company_ids && currentDash.company_ids.length > 0) {
                            companySearch = currentDash.companies
                        }

                        setDashboardViewModalState((prevState) => {
                            return {
                                ...prevState,
                                current_view: currentDash,
                                naicsSpecific: naicsSpecific,
                                parentSpecific: parentSpecific,
                                naicsSearch: naicsSearch,
                                parentSearch: parentSearch,
                                companySearch: companySearch
                            }
                        })
                        setReportMetrics(prevState => {
                            return {
                                ...prevState,
                                id: currentDash.id,
                                layout: layout,
                                peerview_charts: peerviewCharts,
                                pnl: pnlOnePageRows,
                                balance_sheet: balOnePageRows,
                                cash_flow: cashFlowRows,
                                kfis: kfisRows,
                                people_peerview_charts: peoplePeerviewCharts,
                                people_financial_detail: peopleFDRows,
                                people_kpi: peopleKpiRows,
                                customers_peerview_charts: customersPeerviewCharts,
                                customers_financial_detail: customersFDRows,
                                customers_kpi: customersKpiRows,
                                allSelectedMetrics: selectedItems,
                                allSheetMetrics: [...peerviewCharts, ...pnlOnePageRows, ...balOnePageRows, ...cashFlowRows, ...kfisRows, ...peoplePeerviewCharts, ...peopleFDRows, ...peopleKpiRows, ...customersPeerviewCharts, ...customersFDRows, ...customersKpiRows],
                                noChangesMade: true
                            }
                        })
                    }
                } else {
                    setDashboardViewModalState(prevState => {
                        return {
                            ...prevState,
                            current_view: currentDash
                        }
                    })
                    setDashboard(() => {
                        return {
                            id: currentDash.id,
                            selectedItems: currentDash.selected_items,
                            layout: currentDash.dashboard_layout,
                            noChangesMade: true
                        }
                    })
                }
            }
        } catch (error) {
            console.log(error);
            toast.error(`Sorry something went wrong.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const updateDashBoardView = async (e = false, dashId = null, dashViewInfo = null) => {
        if (e) { e.preventDefault() }
        let dashViewId = dashId
        let updatedView = { report_type: 'money', editor_page: true, admin_custom_default: props.admin_editor, normal_custom: !props.admin_editor }

        if (dashViewInfo) {
            if (dashViewInfo.viewApply === 'all_firm_clients_naics') {
                let company = state.child_companies_list.find(c => c[0] === companyForm.id)
                dashViewInfo.naics = [company[3]]
            }
            updatedView['name'] = dashViewInfo.name
            updatedView['private'] = dashViewInfo.viewVisibilty === 'only_me'
            updatedView['permission_details'] = dashViewInfo.viewPermission
            updatedView['view_apply'] = dashViewInfo.viewApply
            updatedView['admin_custom_default'] = props.admin_editor
            updatedView['normal_custom'] = !props.admin_editor
            updatedView['naics'] = dashViewInfo.naics
            updatedView['parent_ids'] = dashViewInfo.parent_ids
            updatedView['company_ids'] = dashViewInfo.company_ids
            updatedView['metric_key'] = dashViewInfo.metricKey
            updatedView['metric_name'] = dashViewInfo.metricName
        }

        if (report === 'money') {
            if (!dashViewId) dashViewId = reportMetrics.id

            updatedView['selected_items'] = {
                peerview_charts: reportMetrics['peerview_charts'],
                pnl: reportMetrics['pnl'],
                balance_sheet: reportMetrics['balance_sheet'],
                cash_flow: reportMetrics['cash_flow'],
                kfis: reportMetrics['kfis'],
                money_all_selected_items: reportMetrics['allSelectedMetrics'],
                money_user_notes: '',
                people_peerview_charts: reportMetrics['people_peerview_charts'],
                people_financial_detail: reportMetrics['people_financial_detail'],
                people_kpi: reportMetrics['people_kpi'],
                customers_peerview_charts: reportMetrics['customers_peerview_charts'],
                customers_financial_detail: reportMetrics['customers_financial_detail'],
                customers_kpi: reportMetrics['customers_kpi'],
            }
            updatedView['dashboard_layout'] = reportMetrics['layout']
            setReportMetrics((prevState) => {
                return { ...prevState, noChangesMade: true }
            })
        }

        try {
            const res = await fetch(`/dashboard_views/${dashViewId}`, {
                method: 'PATCH',
                headers: {
                    'X-CSRF-Token': window.token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedView),
            })
            const dashViewRes = await res.json()

            if (!res.ok) {
                throw new Error('Network response was not ok.');
            } else {
                setDashboardViewModalState(prevState => {
                    if (reportMetrics.id !== dashViewId && report === 'money') {
                        return {
                            ...prevState,
                            user_views: dashViewRes.user_views,
                        }
                    } else {
                        return {
                            ...prevState,
                            current_view: dashViewRes.current_view,
                            user_views: dashViewRes.user_views,
                        }
                    }
                })
                toast.success('Changes to view saved!', {
                    position: 'top-right',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.log(error);
            toast.error('Sorry something went wrong. Changes to view could not be saved.', {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const deleteDashBoardView = async (e, dashViewId) => {
        e.preventDefault()
        let dashboard = dashboardViewModalState.user_views.find(v => v.id === dashViewId)
        let noViewEdit = dashboard.permission_details === 'view_only' && props.user_id !== dashboard.user_id

        if (noViewEdit) {
            toast.error(`Sorry You Are NOT Allowed to Edit this Dashboard View. You need to be the owner of this dashboard view in order to edit.`, {
                position: 'top-right',
                autoClose: 10000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        } else {
            try {
                const res = await fetch(`/dashboard_views/${dashViewId}`, {
                    method: 'DELETE',
                    headers: {
                        'X-CSRF-Token': window.token,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ editor_page: true }),
                })

                if (!res.ok) {
                    throw new Error('Network response was not ok.');
                } else {
                    let newCurrentView = dashboardViewModalState.user_views.length > 0 ? dashboardViewModalState.user_views[0] : {}
                    let currentViewDeleted = dashViewId === dashboardViewModalState.current_view.id
                    setDashboardViewModalState(prevState => {
                        let oldUserViews = prevState.user_views
                        let newUserViews = oldUserViews.filter(v => v.id !== dashViewId)
                        if (currentViewDeleted) {
                            newCurrentView = newUserViews.length > 0 ? newUserViews[0] : {}
                            return {
                                ...prevState,
                                current_view: newCurrentView,
                                user_views: newUserViews,
                            }
                        } else {
                            return {
                                ...prevState,
                                user_views: newUserViews,
                            }
                        }
                    })

                    if (report === 'money' && currentViewDeleted && Object.keys(newCurrentView).length > 0) {
                        let layout = [];
                        let peerviewCharts = null;
                        let peerviewChartsSelected = [];
                        let peopleLayout = [];
                        let peoplePeerviewCharts = [];
                        let peoplePeerviewChartsSelected = [];
                        let peopleFDRows = []
                        let customersLayout = [];
                        let customersPeerviewCharts = [];
                        let customersPeerviewChartsSelected = [];
                        let customersFDRows = []
                        let customersKpiRows = customersKPIsFormat(filters['display_columns_by'], filters['report_period']);

                        if (newCurrentView['selected_items'] && newCurrentView['selected_items']['peerview_charts'].length > 0) {
                            let { selectedItems } = mergeItems(report, newCurrentView['selected_items']['peerview_charts'], []);
                            peerviewCharts = selectedItems;
                            peerviewCharts.forEach((chart) => {
                                if (chart.checked) {
                                    peerviewChartsSelected.push(chart)
                                }
                            })
                            layout = newCurrentView['dashboard_layout']
                        } else {
                            peerviewCharts = moneyCharts['peerview_charts']
                            peerviewCharts.forEach((chart) => {
                                if (chart.checked) {
                                    let defaultLayout = defaultLayouts['money_peerview_charts'].find((l) => l.i === chart.key)
                                    if (defaultLayout) {
                                        layout.push(defaultLayout)
                                        peerviewChartsSelected.push(chart)
                                    }
                                }
                            })
                        }

                        if (newCurrentView['selected_items'] && newCurrentView['selected_items']['people_peerview_charts'] && newCurrentView['selected_items']['people_peerview_charts'].length > 0) {
                            let { selectedItems } = mergeItems('people', newCurrentView['selected_items']['people_peerview_charts'], []);
                            peoplePeerviewCharts = selectedItems;
                        } else {
                            peoplePeerviewCharts = peopleCharts['peerview_charts']
                        }

                        if (newCurrentView['selected_items'] && newCurrentView['selected_items']['customers_peerview_charts'] && newCurrentView['selected_items']['customers_peerview_charts'].length > 0) {
                            let { selectedItems } = mergeItems('customers', newCurrentView['selected_items']['customers_peerview_charts'], []);
                            customersPeerviewCharts = selectedItems;
                        } else {
                            customersPeerviewCharts = customerCharts['peerview_charts']
                        }

                        let displayByView = 'yearsView'
                        if (filters['display_columns_by'] === 'Years' && filters['report_period'] === 'Year to Date') {
                            displayByView = 'ytdView'
                        }
                        if (filters['display_columns_by'] === 'Months') {
                            displayByView = 'monthsView'
                        }

                        if (report === 'money') {
                            let { pnlOnePageRows, balOnePageRows, cashFlowRows, kfisRows } = moneyTreesBuilder(newCurrentView['selected_items'], state.tree, displayByView)
                            let { peopleFinancialDetailRows, peopleKpiRows } = peopleTreesBuilder(newCurrentView['selected_items'], state.tree, displayByView)

                            // People & Customers contain similar metrics found in Money P&L
                            if (!newCurrentView['selected_items']['people_financial_detail']) {
                                peopleFDRows = updatePeopleCustomersChecks(peopleFinancialDetailRows, newCurrentView['selected_items']['pnl'])
                            } else {
                                peopleFDRows = peopleFinancialDetailRows
                            }

                            if (!newCurrentView['selected_items']['customers_financial_detail']) {
                                customersFDRows = updatePeopleCustomersChecks(customersFinancialDetailRows, newCurrentView['selected_items']['pnl'])
                            } else {
                                customersFDRows = updateCustomersRows(newCurrentView['selected_items']['customers_financial_detail'], customersFinancialDetailRows)
                            }

                            if (!newCurrentView['selected_items']['customers_kpi']) {
                                customersKpiRows = updatePeopleCustomersChecks(customersKpiRows, newCurrentView['selected_items']['pnl'])
                            } else {
                                customersKpiRows = updateCustomersRows(newCurrentView['selected_items']['customers_kpi'], customersKpiRows)
                            }

                            let selectedItems = newCurrentView['selected_items']['money_all_selected_items'].length > 0 ? newCurrentView['selected_items']['money_all_selected_items'] : peerviewChartsSelected;
                            newCurrentView.selected_items = selectedItems
                            newCurrentView.dashboard_layout = layout

                            setReportMetrics(prevState => {
                                return {
                                    ...prevState,
                                    id: newCurrentView.id,
                                    layout: layout,
                                    peerview_charts: peerviewCharts,
                                    pnl: pnlOnePageRows,
                                    balance_sheet: balOnePageRows,
                                    cash_flow: cashFlowRows,
                                    kfis: kfisRows,
                                    people_peerview_charts: peoplePeerviewCharts,
                                    people_financial_detail: peopleFDRows,
                                    people_kpi: peopleKpiRows,
                                    customers_peerview_charts: customersPeerviewCharts,
                                    customers_financial_detail: customersFDRows,
                                    customers_kpi: customersKpiRows,
                                    allSelectedMetrics: selectedItems,
                                    allSheetMetrics: [...peerviewCharts, ...pnlOnePageRows, ...balOnePageRows, ...cashFlowRows, ...kfisRows, ...peoplePeerviewCharts, ...peopleFDRows, ...peopleKpiRows, ...customersPeerviewCharts, ...customersFDRows, ...customersKpiRows],
                                    noChangesMade: true
                                }
                            })

                            setDashboardViewModalState((prevState) => {
                                return {
                                    ...prevState,
                                    current_view: newCurrentView
                                }
                            })
                        }
                    }

                    toast.success('Report was deleted!', {
                        position: 'top-right',
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    });
                }
            } catch (error) {
                console.log(error);
                toast.error('Sorry something went wrong. Try again later.', {
                    position: 'top-right',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                });
            }
        }
    }

    const handleDashboardViewModal = (action, info = null) => {
        setDashboardViewModalState(prevState => {
            if (action === 'close') {
                return { ...prevState, isOpen: false, action: 'close' }
            } else if (action === 'edit_view') {
                let currentView = prevState.current_view
                let currentInfo = !info ? currentView : info
                let noViewEdit = currentInfo.permission_details === 'view_only' && props.user_id !== currentInfo.user_id

                if (noViewEdit) {
                    toast.error(`Sorry You Are NOT Allowed to Edit this Dashboard View. You need to be the owner of this dashboard view in order to edit.`, {
                        position: 'top-right',
                        autoClose: 10000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    });
                    return prevState
                } else {
                    let naicsSpecific = 'no';
                    let parentSpecific = 'no';
                    let naicsSearch = [];
                    let parentSearch = [];
                    let companySearch = [];

                    if (currentInfo.naics && currentInfo.naics.length > 0) {
                        naicsSpecific = 'yes'
                        naicsSearch = currentInfo.naics
                    }
                    if (currentInfo.parent_ids && currentInfo.parent_ids.length > 0) {
                        parentSpecific = 'yes'
                        parentSearch = currentInfo.parent_companies
                    }
                    if (currentInfo.company_ids && currentInfo.company_ids.length > 0) {
                        companySearch = currentInfo.parent_companies
                    }
                    return { ...prevState, isOpen: true, action: action, displayViewPermissionQ: currentInfo.private, viewPermission: currentInfo.permission_details, viewApply: currentInfo.view_apply, edit_view: currentInfo, naicsSpecific: naicsSpecific, parentSpecific: parentSpecific, naicsSearch: naicsSearch, parentSearch: parentSearch, companySearch: companySearch, metric_key: currentInfo.metric_key, metric_name: currentInfo.metric_name }
                }
            } else {
                return { ...prevState, isOpen: true, action: action, edit_view: {}, naicsSpecific: 'no', parentSpecific: 'no', naicsSearch: [], parentSearch: [], companySearch: [], metric_key: null, metric_name: null }
            }
        })
    }

    const handleOnLayoutChange = (dashBoardType, newLayout, parentLayout = null) => {
        let currentView = dashboardViewModalState.current_view
        let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)

        if (dashBoardType === 'normalDashboard') {
            setDashboard((prevState) => {
                let oldLayout = prevState.layout;
                let modifiedLayout = oldLayout.map((ol) => {
                    let findNewItem = newLayout.find(item => item.i === ol.i)
                    if (findNewItem) {
                        return { ...ol, ...findNewItem }
                    } else {
                        return ol;
                    }
                })

                return { ...prevState, layout: modifiedLayout, noChangesMade: noChangesVal }
            })
        }

        if (dashBoardType === 'parentMyDashBoard') {
            setReportMetrics((prevState) => {
                let oldLayout = prevState.layout;
                let modifiedLayout = oldLayout.map((ol) => {
                    let findNewItem = newLayout.find(item => item.i === ol.i)
                    if (findNewItem) {
                        return { ...ol, ...findNewItem }
                    } else {
                        return ol;
                    }
                })
                return { ...prevState, layout: modifiedLayout, noChangesMade: noChangesVal }
            })
        }

        if (dashBoardType === 'childMyDashBoard') {
            setReportMetrics((prevState) => {
                let modifiedLayout = _.cloneDeep(prevState.layout);
                let findParentLayout = modifiedLayout.find(ol => ol.i === parentLayout.key)
                let findParentLayoutIndex = modifiedLayout.findIndex(ol => ol.i === parentLayout.key)
                if (findParentLayout) {
                    findParentLayout.layout = findParentLayout.layout.map(pl => {
                        let findNewItem = newLayout.find(item => item.i === pl.i)
                        if (findNewItem) {
                            return { ...pl, ...findNewItem }
                        } else {
                            return pl;
                        }
                    })

                    modifiedLayout[findParentLayoutIndex] = findParentLayout
                }
                return { ...prevState, layout: modifiedLayout, noChangesMade: noChangesVal }
            })
        }
    }

    const handleToggleDraggable = (key, dashType = '', parent = null, customKey = '') => {
        let currentView = dashboardViewModalState.current_view
        let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)
        if (dashType === 'moneyDashboard') {
            setReportMetrics((prevState) => {
                let newLayout = _.cloneDeep(prevState.layout);

                if (parent) {
                    let parentIndex = newLayout.findIndex((l) => l.i === parent.key);
                    if (parentIndex > -1) {
                        let childIndex = parent.layout.findIndex((child) => child.key === key)
                        if (childIndex > -1) {
                            newLayout[parentIndex].isDraggable = !newLayout[parentIndex].isDraggable
                            newLayout[parentIndex]['layout'][childIndex].isDraggable = newLayout[parentIndex].isDraggable
                        }
                    }
                } else {
                    let itemIndex = newLayout.findIndex((l) => l.i === key);
                    if (itemIndex > -1) {
                        newLayout[itemIndex].isDraggable = !newLayout[itemIndex].isDraggable
                    }
                }
                return { ...prevState, layout: newLayout, noChangesMade: noChangesVal }
            })
        } else {
            setDashboard((prevState) => {
                let newLayout = _.cloneDeep(prevState.layout);
                let itemIndex = newLayout.findIndex((l) => l.i === key);
                if (itemIndex > -1) {
                    newLayout[itemIndex].isDraggable = !newLayout[itemIndex].isDraggable
                }
                return { ...prevState, layout: newLayout, noChangesMade: noChangesVal }
            })
        }
    }

    const handleEditMetrics = (e = false, selectionEditForm = false) => {
        if (e) { e.preventDefault() }

        setReportMetrics(prevState => {
            if (selectionEditForm) {
                updateDashBoardView()
                return {
                    ...prevState,
                    noChangesMade: true,
                }
            } else {
                if (prevState.editMetrics) {
                    updateDashBoardView()
                }
                return {
                    ...prevState,
                    editMetrics: !prevState.editMetrics,
                    noChangesMade: true,
                }
            }
        })
    }

    const updatePeopleCustomersChecks = (updatingRows, referenceRows) => {
        updatingRows.forEach(p => {
            let moneyItem = referenceRows.find(item => item.key === p.key)
            if (moneyItem && moneyItem.checked) {
                p.checked = true
                p.layout = p.layout.map(l => {
                    let lItem = moneyItem.layout.find(m => m.key === l.key)
                    if (lItem && lItem.checked) {
                        l.checked = true
                    }
                    return l
                })
            }
        })

        return updatingRows
    }

    const mergeMonthlyData = (existing, incoming) => {
        const merged = { ...existing };

        Object.keys(incoming).forEach((key) => {
            merged[key] = merged[key] || {};

            Object.keys(incoming[key]).forEach((year) => {
                merged[key][year] = {
                    ...(merged[key][year] || {}),
                    ...incoming[key][year]
                };
            });
        });

        return merged;
    };

    // Fetch Dashboard layouts based on report type, years vs monthly/ytd, displaying which charts on dashboard
    const fetchCalcs = async (args, { filters, report, ...prevState }) => {
        // save any checked metrics and dashboard changes
        // if (reportMetrics.editMetrics) { handleEditMetrics() }
        let previousFilterOptions, previousNaicsCode, previousRegion, previousRevenueBand, previousYear;
        let survey = null;
        let surveyCharts = [];
        if (Object.keys(prevState.filterOptions).length > 0) {
            previousFilterOptions = prevState.filterOptions;
            previousNaicsCode = previousFilterOptions.code;
            previousRegion = previousFilterOptions.region;
            previousRevenueBand = previousFilterOptions.revenue_band;
            previousYear = previousFilterOptions.year;
        }

        let companyId = args.id ? args.id : props.id
        let knownYears = trendData ? Object.keys(trendData['total_revenue']) : []

        try {
            const calculations = await fetch('/api/v1/calculations', {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': window.token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    company_id: companyId,
                    known_years: knownYears,
                    filters,
                    report,
                    ...args // over write current state with new args
                }),
            });
            const calcsRes = await calculations.json();
            // console.log(calcsRes, 'calcRes')
            // const dashBoardRes = await dashBoard.json();
            // let currentDash = dashBoardRes['current_view'];
            const { reportSpecific, filterOptions, ...newState } = calcsRes
            let newTrendData = mergeMonthlyData(trendData, newState.trendData);
            const finalFilterOptions = {};
            let currentDash = {
                selected_items: {
                    money_all_selected_items: reportMetrics['allSelectedMetrics'],
                    peerview_charts: reportMetrics['peerview_charts'],
                    pnl: reportMetrics['pnl'],
                    balance_sheet: reportMetrics['balance_sheet'],
                    cash_flow: reportMetrics['cash_flow'],
                    kfis: reportMetrics['kfis'],
                    people_peerview_charts: reportMetrics['people_peerview_charts'],
                    people_financial_detail: reportMetrics['people_financial_detail'],
                    people_kpi: reportMetrics['people_kpi'],
                    customers_peerview_charts: reportMetrics['customers_peerview_charts'],
                    customers_financial_detail: reportMetrics['customers_financial_detail'],
                    customers_kpi: reportMetrics['customers_kpi'],
                },
                dashboard_layout: reportMetrics['layout']
            }

            if (props.current_view.selected_items && props.current_view.selected_items['peerview_charts']) {
                currentDash = props.current_view
            }

            if (filterOptions && filterOptions['number_of_pros']) { finalFilterOptions['number_of_pros'] = filterOptions['number_of_pros'] }
            let finalNaicsCode, finalRegion, finalRevenueBand, finalYear;
            let naicsCode = filterOptions.code;
            let region = filterOptions.region;
            let revenueBand = filterOptions.revenue_band;
            let year = filterOptions.year;

            if (Object.keys(prevState.filterOptions).length > 0) {
                let mergedNaicsCodes = [...previousNaicsCode, ...naicsCode]
                let previousCodeNumbers = previousNaicsCode.map((n) => n[0])
                let newCodeNumbers = naicsCode.map((n) => n[0])
                let allNaicsCodeNumbers = previousCodeNumbers.concat(newCodeNumbers.filter((n) => !previousCodeNumbers.includes(n)))
                let sortedNaicsCodes = allNaicsCodeNumbers.sort()
                finalNaicsCode = sortedNaicsCodes.map((n) => {
                    let naicsCode = mergedNaicsCodes.find((mc) => mc[0] === n)
                    return naicsCode
                })
                finalRegion = previousRegion.concat(region.filter((r) => !previousRegion.includes(r)))
                finalRevenueBand = previousRevenueBand.concat(revenueBand.filter((rb) => !previousRevenueBand.includes(rb)))
                finalYear = previousYear.concat(year.filter((y) => !previousYear.includes(y)))
                finalFilterOptions.code = finalNaicsCode
                finalFilterOptions.region = finalRegion;
                finalFilterOptions.revenue_band = finalRevenueBand;
                finalFilterOptions.year = finalYear;
            } else {
                finalFilterOptions.code = naicsCode;
                finalFilterOptions.region = region;
                finalFilterOptions.revenue_band = revenueBand;
                finalFilterOptions.year = year;
            }

            if (report === 'money') {
                let allSelectedKeys = []
                let layout = [];
                let peerviewCharts = null;
                let peerviewChartsSelected = [];
                let peopleLayout = [];
                let peoplePeerviewCharts = [];
                let peoplePeerviewChartsSelected = [];
                let peopleFDRows = []
                let customersLayout = [];
                let customersPeerviewCharts = [];
                let customersPeerviewChartsSelected = [];
                let customersFDRows = []
                let customersKpiRows = customersKPIsFormat('Years');

                if (currentDash['selected_items'] && currentDash['selected_items']['peerview_charts'].length > 0) {
                    let { selectedItems } = mergeItems('money', currentDash['selected_items']['peerview_charts'], []);
                    peerviewCharts = selectedItems;
                    peerviewCharts.forEach((chart) => {
                        if (chart.checked) {
                            peerviewChartsSelected.push(chart)
                        }
                    })
                    layout = currentDash['dashboard_layout']
                } else {
                    peerviewCharts = moneyCharts['peerview_charts']
                    peerviewCharts.forEach((chart) => {
                        if (chart.checked) {
                            let defaultLayout = defaultLayouts['money_peerview_charts'].find((l) => l.i === chart.key)
                            if (defaultLayout) {
                                layout.push(defaultLayout)
                                peerviewChartsSelected.push(chart)
                            }
                        }
                    })
                }

                if (currentDash['selected_items'] && currentDash['selected_items']['people_peerview_charts'] && currentDash['selected_items']['people_peerview_charts'].length > 0) {
                    let { selectedItems } = mergeItems('people', currentDash['selected_items']['people_peerview_charts'], []);
                    peoplePeerviewCharts = selectedItems;
                } else {
                    peoplePeerviewCharts = peopleCharts['peerview_charts']
                }

                if (currentDash['selected_items'] && currentDash['selected_items']['customers_peerview_charts'] && currentDash['selected_items']['customers_peerview_charts'].length > 0) {
                    let { selectedItems } = mergeItems('customers', currentDash['selected_items']['customers_peerview_charts'], []);
                    customersPeerviewCharts = selectedItems;
                } else {
                    customersPeerviewCharts = customerCharts['peerview_charts']
                }

                let { pnlOnePageRows, balOnePageRows, cashFlowRows, kfisRows } = moneyTreesBuilder(currentDash['selected_items'], newState.tree)
                let { peopleFinancialDetailRows, peopleKpiRows } = peopleTreesBuilder(currentDash['selected_items'], newState.tree)

                // People & Customers contain similar metrics found in Money P&L
                if (!currentDash['selected_items']['people_financial_detail']) {
                    peopleFDRows = updatePeopleCustomersChecks(peopleFinancialDetailRows, currentDash['selected_items']['pnl'])
                } else {
                    peopleFDRows = peopleFinancialDetailRows
                }

                if (!currentDash['selected_items']['customers_financial_detail']) {
                    customersFDRows = updatePeopleCustomersChecks(customersFinancialDetailRows, currentDash['selected_items']['pnl'])
                } else {
                    customersFDRows = updateCustomersRows(currentDash['selected_items']['customers_financial_detail'], customersFinancialDetailRows)
                }

                if (!currentDash['selected_items']['customers_kpi']) {
                    customersKpiRows = updatePeopleCustomersChecks(customersKpiRows, currentDash['selected_items']['pnl'])
                } else {
                    customersKpiRows = updateCustomersRows(currentDash['selected_items']['customers_kpi'], customersKpiRows)
                }

                let selectedItems = currentDash['selected_items']['money_all_selected_items'].length > 0 ? currentDash['selected_items']['money_all_selected_items'] : peerviewChartsSelected;

                setReportMetrics(prevState => {
                    return {
                        ...prevState,
                        id: currentDash.id || 0,
                        layout: layout,
                        peerview_charts: peerviewCharts,
                        pnl: pnlOnePageRows,
                        balance_sheet: balOnePageRows,
                        cash_flow: cashFlowRows,
                        kfis: kfisRows,
                        people_peerview_charts: peoplePeerviewCharts,
                        people_financial_detail: peopleFDRows,
                        people_kpi: peopleKpiRows,
                        customers_peerview_charts: customersPeerviewCharts,
                        customers_financial_detail: customersFDRows,
                        customers_kpi: customersKpiRows,
                        allSelectedMetrics: selectedItems,
                        allSheetMetrics: [...peerviewCharts, ...pnlOnePageRows, ...balOnePageRows, ...cashFlowRows, ...kfisRows, ...peoplePeerviewCharts, ...peopleFDRows, ...peopleKpiRows, ...customersPeerviewCharts, ...customersFDRows, ...customersKpiRows],
                        noChangesMade: true
                    }
                })

                currentDash.selected_items = selectedItems
                currentDash.dashboard_layout = layout

                if (!dashboardViewModalState.current_view) {
                    setDashboardViewModalState((prevState) => {
                        return {
                            ...prevState,
                            current_view: currentDash,
                        }
                    })
                }

            }

            setState(prevState => {
                return {
                    ...prevState,
                    ...newState,
                    trendData: newTrendData,
                    filterOptions: finalFilterOptions,
                    reportSpecific,
                    loading: false,
                    pnlTree: pnlTree,
                    balTree: balTree
                }
            });

            setNaicsForm((prevState) => {
                let naicsInfo = state.naics_list.find(n => n[0] == newState.naics_id)
                return {
                    naics_id: newState.naics_id,
                    naics_code: naicsInfo[1],
                    naics_name: naicsInfo[2],
                }
            })

        } catch (error) {
            console.log(error, 'error')
            setState(prevState => {
                return {
                    ...prevState,
                    loading: false
                }
            });
            toast.error('Sorry something went wrong. Please try again later.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        }
    }

    async function submitFilters(event, filters = {}) {
        event.preventDefault();
        let allFilters = {
            id: companyForm.id,
        }
        updateState(allFilters);
    }

    async function updateState(args = {}) {
        setState(prevState => {
            if (args.filters) {
                if (args.filters['display_columns_by'] === 'Years' && args.filters['report_period'] === 'Year to Date') {
                    fetchMonthlyCalcs(args, prevState);
                } else if (args.filters['display_columns_by'] === 'Years' && args.filters['report_period'] !== 'Year to Date') {
                    fetchCalcs(args, prevState);
                } else if (args.filters['display_columns_by'] === 'Months') {
                    fetchMonthlyCalcs(args, prevState)
                } else {
                    fetchCalcs(args, prevState);
                }
            } else {
                fetchCalcs(args, prevState);
            }

            if (args.report) {
                return {
                    ...prevState, report: args.report, loading: true
                }
            } else {
                return {
                    ...prevState, loading: true
                }
            }
        });
    };

    const handleMetricNotes = (parentKey, text) => {
        setReportMetrics((prevState) => {
            let oldLayout = _.cloneDeep(prevState.layout)
            // Save notes to parent
            let newLayout = oldLayout.map(parentItem => {
                if (parentItem['metricRow'] && parentItem['metricRow']['relatedCheckedKey'] === parentKey) {
                    parentItem['metricRow']['notes'] = text
                }
                return parentItem
            })

            return {
                ...prevState,
                layout: newLayout,
                noChangesMade: false
            }
        })
    }

    const openFiltersModal = () => {
        setFiltersModalIsOpen(true)
    }

    const closeFiltersModal = () => {
        setFiltersModalIsOpen(false)
    }

    useEffect(() => {
        if (state.fetch) {
            updateState();
            props.tour_data && !props.tour_data.tour_taken ? setIsOpen(true) : null
        };
    }, []);


    const renderEditDashboard = () => {
        return (
            <div className='edit-dashboard-section'>
                {reportMetrics.noChangesMade ? null : <button className='save-dashboard-btn' onClick={() => updateDashBoardView()}>Save Changes</button>}
                <EditParentChildDashboard
                    allMetrics={reportMetrics}
                    editDashboard={editDashboard}
                    editorPage={true}
                    handleEditDashBoard={handleEditDashBoard}
                    handleEditMetrics={handleEditMetrics}
                    handleSelectAndLayout={handleSelectAndLayout}
                    naicsForm={naicsForm}
                    page={'money'}
                />
            </div>
        )
    }

    const getNaicsChartOfAccounts = async (e) => {
        e.preventDefault()
        const res = await fetch(`/api/v1/coa/?id=${naicsForm.naics_id}`, {
            method: 'GET',
            headers: {
                'X-CSRF-Token': window.token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const resJson = await res.json();

        setState(prevState => {
            return {
                ...prevState,
                tree: resJson.coa
            }
        })

        let currentDash = {
            selected_items: {
                peerview_charts: reportMetrics['peerview_charts'],
                pnl: reportMetrics['pnl'],
                balance_sheet: reportMetrics['balance_sheet'],
                cash_flow: reportMetrics['cash_flow'],
                kfis: reportMetrics['kfis'],
                money_all_selected_items: reportMetrics['allSelectedMetrics'],
                money_user_notes: '',
                people_peerview_charts: reportMetrics['people_peerview_charts'],
                people_financial_detail: reportMetrics['people_financial_detail'],
                people_kpi: reportMetrics['people_kpi'],
                customers_peerview_charts: reportMetrics['customers_peerview_charts'],
                customers_financial_detail: reportMetrics['customers_financial_detail'],
                customers_kpi: reportMetrics['customers_kpi'],
            },
            dashboard_layout: reportMetrics['layout']
        }

        let layout = currentDash['dashboard_layout'];
        let peerviewCharts = null;
        let peerviewChartsSelected = [];
        let peopleLayout = [];
        let peoplePeerviewCharts = [];
        let peoplePeerviewChartsSelected = [];
        let peopleFDRows = []
        let customersLayout = [];
        let customersPeerviewCharts = [];
        let customersPeerviewChartsSelected = [];
        let customersFDRows = []
        let customersKpiRows = customersKPIsFormat('Years');

        if (currentDash['selected_items'] && currentDash['selected_items']['peerview_charts'].length > 0) {
            let { selectedItems } = mergeItems(report, currentDash['selected_items']['peerview_charts'], []);
            peerviewCharts = selectedItems;
            peerviewCharts.forEach((chart) => {
                if (chart.checked) {
                    peerviewChartsSelected.push(chart)
                }
            })
        } else {
            peerviewCharts = moneyCharts['peerview_charts']
            peerviewCharts.forEach((chart) => {
                if (chart.checked) {
                    let defaultLayout = defaultLayouts['money_peerview_charts'].find((l) => l.i === chart.key)
                    if (defaultLayout) {
                        layout.push(defaultLayout)
                        peerviewChartsSelected.push(chart)
                    }
                }
            })
        }

        if (currentDash['selected_items'] && currentDash['selected_items']['people_peerview_charts'] && currentDash['selected_items']['people_peerview_charts'].length > 0) {
            let { selectedItems } = mergeItems('people', currentDash['selected_items']['people_peerview_charts'], []);
            peoplePeerviewCharts = selectedItems;
        } else {
            peoplePeerviewCharts = peopleCharts['peerview_charts']
        }

        if (currentDash['selected_items'] && currentDash['selected_items']['customers_peerview_charts'] && currentDash['selected_items']['customers_peerview_charts'].length > 0) {
            let { selectedItems } = mergeItems('customers', currentDash['selected_items']['customers_peerview_charts'], []);
            customersPeerviewCharts = selectedItems;
        } else {
            customersPeerviewCharts = customerCharts['peerview_charts']
        }

        let displayByView = 'yearsView'
        if (filters['display_columns_by'] === 'Years' && filters['report_period'] === 'Year to Date') {
            displayByView = 'ytdView'
        }
        if (filters['display_columns_by'] === 'Months') {
            displayByView = 'monthsView'
        }


        let { pnlOnePageRows, balOnePageRows, cashFlowRows, kfisRows } = moneyTreesBuilder(currentDash['selected_items'], resJson.coa, displayByView)
        let { peopleFinancialDetailRows, peopleKpiRows } = peopleTreesBuilder(currentDash['selected_items'], resJson.coa, displayByView)

        // People & Customers contain similar metrics found in Money P&L
        if (!currentDash['selected_items']['people_financial_detail']) {
            peopleFDRows = updatePeopleCustomersChecks(peopleFinancialDetailRows, currentDash['selected_items']['pnl'])
        } else {
            peopleFDRows = peopleFinancialDetailRows
        }

        if (!currentDash['selected_items']['customers_financial_detail']) {
            customersFDRows = updatePeopleCustomersChecks(customersFinancialDetailRows, currentDash['selected_items']['pnl'])
        } else {
            customersFDRows = updateCustomersRows(currentDash['selected_items']['customers_financial_detail'], customersFinancialDetailRows)
        }

        if (!currentDash['selected_items']['customers_kpi']) {
            customersKpiRows = updatePeopleCustomersChecks(customersKpiRows, currentDash['selected_items']['pnl'])
        } else {
            customersKpiRows = updateCustomersRows(currentDash['selected_items']['customers_kpi'], customersKpiRows)
        }

        let selectedItems = currentDash['selected_items']['money_all_selected_items'].length > 0 ? currentDash['selected_items']['money_all_selected_items'] : peerviewChartsSelected;
        currentDash.selected_items = selectedItems
        currentDash.dashboard_layout = layout

        setReportMetrics(prevState => {
            return {
                ...prevState,
                layout: layout,
                peerview_charts: peerviewCharts,
                pnl: pnlOnePageRows,
                balance_sheet: balOnePageRows,
                cash_flow: cashFlowRows,
                kfis: kfisRows,
                people_peerview_charts: peoplePeerviewCharts,
                people_financial_detail: peopleFDRows,
                people_kpi: peopleKpiRows,
                customers_peerview_charts: customersPeerviewCharts,
                customers_financial_detail: customersFDRows,
                customers_kpi: customersKpiRows,
                allSelectedMetrics: selectedItems,
                allSheetMetrics: [...peerviewCharts, ...pnlOnePageRows, ...balOnePageRows, ...cashFlowRows, ...kfisRows, ...peoplePeerviewCharts, ...peopleFDRows, ...peopleKpiRows, ...customersPeerviewCharts, ...customersFDRows, ...customersKpiRows],
                noChangesMade: true
            }
        })

        setDashboardViewModalState((prevState) => {
            return {
                ...prevState,
                current_view: currentDash
            }
        })

        setNaicsForm((prevState) => {
            let naicsInfo = state.naics_list.find(n => n[0] == naicsForm.naics_id)
            return {
                ...prevState,
                naics_code: naicsInfo[1],
                naics_name: naicsInfo[2],
            }
        })
    }

    const handleNaicsCodeSelection = ({ target }) => {
        setNaicsForm((prevState) => {
            return {
                ...prevState,
                naics_id: Number(target.value)
            }
        })
    }

    const handleCompanySelection = ({ target }) => {
        setCompanyForm((prevState) => {
            return {
                ...prevState,
                id: Number(target.value)
            }
        })
    }

    const { loading, report, pageTitle, calendarYearEnd, fiscalYearStartMonth, peerviewMetricsYears, calcs, monthly_calcs, baseCalc, monthlyForecastCalcs, tree, pnlTree, balTree, yearRange, n, docs_n, filters, filterOptions, insufficient_data, insufficient_peer_data, reportSpecific, isMonthlyAvailable, quarterMonths, trendData, fiscalYearEnd, companyYTDDate, aggregateYTDDate, companyReportSurvey, surveyTaken, surveyResults } = state;

    const monthsObjBuilder = (fiscalYearStartMonth = 1, reportPeriod = 'Trailing 12', year = null) => {
        const monthsObj = {
            1: 'JAN',
            2: 'FEB',
            3: 'MAR',
            4: 'APR',
            5: 'MAY',
            6: 'JUN',
            7: 'JUL',
            8: 'AUG',
            9: 'SEP',
            10: 'OCT',
            11: 'NOV',
            12: 'DEC'
        }
        if (reportPeriod === 'Trailing 12') {
            let months = Object.values(monthsObj)
            const d = new Date();
            let monthIndex = d.getMonth();
            let startMonths = months.splice(monthIndex)
            let nextMonth = 1

            startMonths.forEach((f, i) => {
                monthsObj[i + 1] = f + ' ' + Number(year - 1)
                nextMonth++
            })

            months.forEach((f, i) => {
                monthsObj[nextMonth] = f + ' ' + year
                nextMonth++
            })

        } else {
            if (fiscalYearStartMonth !== 1) {
                let months = Object.values(monthsObj)
                let startMonths = months.splice(fiscalYearStartMonth - 1)
                let fiscalMonths = [...startMonths, ...months]
                fiscalMonths.forEach((f, i) => {
                    monthsObj[i + 1] = f
                })
            }
        }

        return monthsObj
    }

    const compareWithRowKeys = {
        'None': null,
        'Practice': 'practice_avg',
        'Peers': 'avg',
        'NSCHBC': 'nschbc',
        'Peers - Top 10% Fastest Growing': 'top_10_revenue_growth',
        'Peers - Top 25% Fastest Growing': 'top_25_revenue_growth',
        'Peers - Top 10% Most Profitable': 'top_10_net_profit',
        'Peers - Top 25% Most Profitable': 'top_25_net_profit'
    }

    const createCompareWithTitle = (compareWith) => {
        let colonIndex = compareWith.indexOf(':')
        return compareWith.slice(colonIndex + 1)
    }

    const compareWith = filters.compare_with || null;
    const calcsAvgType = compareWithRowKeys[compareWith]
    // const monthsObj = monthsObjBuilder(props.fiscalYearStartMonth, filters.report_period, filters.filters.year)
    // let monthLabels = props.calendarYearEnd ? ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'] : ['Month 1', 'Month 2', 'Month 3', 'Month 4', 'Month 5', 'Month 6', 'Month 7', 'Month 8', 'Month 9', 'Month 10', 'Month 11', 'Month 12']
    // if (filters.report_period === 'Trailing 12') {
    //     monthLabels = Object.values(monthsObj)
    // }
    // let monthlyCompareWithTitle = createCompareWithTitle(compareWith)

    return (
        <div className={`${report}-content report-content`} style={{ opacity: (loading ? 0.6 : 1) }} >
            <ToastContainer
                position='top-right'
                autoClose={30000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                theme='colored'
                pauseOnHover
            />
            <div id='sticky-topnav-right-btns'>
                <TourBtn />
            </div>
            <div className='dashboard-view-editor-header'>
                <h1>{props.admin_editor ? "Admin Custom Reports Builder" : "Custom Reports Builder"}</h1>
                <div className='dashboard-view-naics-coa'>
                    {!props.admin_editor &&
                        <form className='company-selection-form' onSubmit={(e) => submitFilters(e)}>
                            <label htmlFor='company-select'>Viewing Client:</label>
                            <select name='company-select' value={companyForm.id} onChange={handleCompanySelection}>
                                {
                                    state.child_companies_list.map((company) => {
                                        let labelName = company[2] ? `${company[1]} / ${company[2]}, NAICS: ${company[3]}` : `${company[1]}, NAICS: ${company[3]}`
                                        return (<option key={company[0]} value={company[0]}>{labelName}</option>)
                                    })
                                }
                            </select>
                            <button className='btn btn-primary' type='submit'>Change Company</button>
                        </form>
                    }
                    <form className='naics-code-selection-form' onSubmit={(e) => getNaicsChartOfAccounts(e)}>
                        <label htmlFor='naics-code-select'>Current NAICS Code (Use to Change Chart of Accounts):</label>
                        <select name='naics-code-select' value={naicsForm.naics_id} onChange={handleNaicsCodeSelection}>
                            {
                                state.naics_list.map((naics) => {
                                    if (naics[1] === 'master') {
                                        return (<option key={naics[0]} value={naics[0]}>{naics[1]}</option>)
                                    } else {
                                        return (<option key={naics[0]} value={naics[0]}>{`${naics[1]}-${naics[2]}`}</option>)
                                    }
                                })
                            }
                        </select>
                        <button className='btn btn-primary' type='submit'>Apply NAICS Code</button>
                    </form>
                </div>
            </div>
            {/* <Modal
                className={{
                    base: 'client-modal-content',
                    afterOpen: 'client-modal-content_after-open',
                    beforeClose: 'client-modal-content_before-close',
                }}
                overlayClassName={{
                    base: 'overlay-base',
                    afterOpen: 'overlay-base_after-open',
                    beforeClose: 'overlay-base_before-close',
                }}
                isOpen={filtersModalIsOpen}
                onRequestClose={closeFiltersModal}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={0}
                contentLabel='Report Filters Modal'
            >
                <div className='money-dropdown-container'>
                    <header className='company-modal-header'>
                        <h1 className='client-company-name'>Report Filters</h1>
                    </header>
                    <div className='report-filters-container'>
                        <div className='client-info-div'>
                            {props.name ? <p>CLIENT ID: {props.name}</p> : null}
                            {props.real_name ? <p>CLIENT NAME: {props.real_name}</p> : null}
                            <p>FISCAL YEAR END: {props.fiscal_year_end}</p>
                            <p>NAICS: {props.code}, {props.industry}</p>
                        </div>
                        <DropdownFilter
                            clas={'money-dropdown-filters'}
                            calendarYearEnd={calendarYearEnd}
                            current={filters}
                            // getMonthlyForecastScenario={getMonthlyForecastScenario}
                            isMonthlyAvailable={isMonthlyAvailable}
                            monthlyCompareWithOptions={state.monthlyCompareWithOptions}
                            naicsCode={props.code}
                            options={filterOptions}
                            youAnnualOptions={state.youAnnualOptions}
                            youMonthlyOptions={state.youMonthlyOptions}
                            peerAnnualOptions={state.peerAnnualOptions}
                            peerMonthlyOptions={state.peerMonthlyOptions}
                            onClick={submitFilters}
                            report={report}
                        />
                    </div>
                </div>
            </Modal> */}
            <DashboardViewModal
                adminEditor={props.admin_editor}
                editorPage={true}
                dashboardViewModalState={dashboardViewModalState}
                report={'money'}
                handleDashboardViewModal={handleDashboardViewModal}
                createDashBoardView={createDashBoardView}
                deleteDashBoardView={deleteDashBoardView}
                updateDashBoardView={updateDashBoardView}
            />
            <ul id='nav-tabs-money-report' className='report-tab-list' role='tablist'>
                <div>
                    <DashboardViewControls
                        editorPage={true}
                        report={'money'}
                        dashboardViewModalState={dashboardViewModalState}
                        getDashBoardView={getDashBoardView}
                        handleDashboardViewModal={handleDashboardViewModal}
                    />
                </div>
                {renderEditDashboard()}
            </ul>

            <Data.Provider value={{ calcs, monthly_calcs }}>
                <ParentDashboard
                    aggregateYTDDate={aggregateYTDDate}
                    calcsAvgType={calcsAvgType}
                    clientName={state.clientName}
                    companyYTDDate={companyYTDDate}
                    compareWith={filters.compare_with}
                    dashboardLayout={reportMetrics['layout']}
                    displayColumnsBy={filters.display_columns_by}
                    handleMetricNotes={handleMetricNotes}
                    handleMoneyNotes={handleMoneyNotes}
                    handleOnLayoutChange={handleOnLayoutChange}
                    handleToggleDraggable={handleToggleDraggable}
                    calendarYearEnd={calendarYearEnd}
                    fiscalYearEnd={fiscalYearEnd}
                    forecastName={''}
                    forecastVals={{}}
                    naicsCode={props.code}
                    page={'money'}
                    quarterMonths={quarterMonths}
                    trendData={trendData}
                    reportPeriod={filters.report_period}
                    reportMetrics={reportMetrics}
                    tree={tree}
                    year={filters.year}
                    yearRange={yearRange}
                // monthlyCompareWithTitle={monthlyCompareWithTitle}
                // myNotes={moneyNotes}
                // handleEditChartModal={handleEditChartModal}
                // monthLabels={monthLabels}
                />
            </Data.Provider>
        </div>
    )
}

export default DashboardViewEditorPage;